import moment from 'moment';
import { EMPTY_VALUE } from '../internalRoles';
import { PROFILE_DATE_TIME_FORMAT } from './dateFormat';

const SKIPPED_SCORE_LABEL = 'Skipped';

const toScoreLabel = ({ score, skipped }) => {
  if (skipped) return SKIPPED_SCORE_LABEL;
  // Neither skipped nor scored: the merged handler cannot produce this (the
  // migration bridge drops out-of-range scores); it only keeps "null" off screen.
  if (score === null || score === undefined) return EMPTY_VALUE;

  return String(score);
};

/**
 * Maps auth-service's admin NPS list onto the tab's rows, keeping the API's
 * newest-first order. The answers carry no identifier, so the key pairs the
 * timestamp with the position: two answers in the same instant stay distinct.
 *
 * @param {import('../types/NpsReview.api').IGetNpsReviewsApiResponse} [response]
 * @returns {import('../types/NpsReview').INpsReviewRow[]}
 */
export const toNpsReviewRows = (response) =>
  (response?.data?.items ?? []).map((item, index) => ({
    key: `${item.createdAt}-${index}`,
    dateLabel: moment(item.createdAt).format(PROFILE_DATE_TIME_FORMAT),
    scoreLabel: toScoreLabel(item),
  }));

/**
 * NPS adapters, grouped to match the `UserAdapters` convention.
 */
export const NpsReviewAdapters = {
  toNpsReviewRows,
};
